'use client';

import { Box, BoxProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

export const StyledTooltipContainer = styled(Box)<BoxProps>`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  text-decoration: none;

  &[data-internal-icons-tooltip] {
    &::after {
      content: attr(data-internal-icons-tooltip);
      position: absolute;
      top: calc(100% + ${({ theme }) => theme.spacing[200]});
      padding: ${({ theme }) => theme.spacing[100]} ${({ theme }) => theme.spacing[200]};
      margin-left: ${({ theme }) => theme.spacing[100]};
      border-radius: ${({ theme }) => theme.borderRadius[100]};
      background-color: ${({ theme }) => theme.color.background.backdropSubtle};
      color: ${({ theme }) => theme.color.background.interactiveControlBase};
      font-size: ${({ theme }) => theme.typography.fontSize.xs};
      white-space: nowrap;
      visibility: hidden;
      opacity: 0;
      transition: all 0.2s ease;
      z-index: 100;
      text-decoration: none;
      pointer-events: none;
    }

    &:hover {
      &::after {
        visibility: visible;
        opacity: 1;
      }
    }
  }
`;
